import axios from 'axios';

const { CancelToken } = axios;

const get = async (url, withAuth = true, cancelToken = (c) => {}) => {
  const config = {
    headers: {
      'Content-Type': 'application/json',
    },
    cancelToken: new CancelToken(cancelToken),
  };
  if (withAuth) {
    try {
      const auth = await authHeader();
      config.headers = { ...config.headers, ...auth };
    } catch (e) {
      return e;
    }
  }

  return axios.get(`${process.env.REACT_APP_HOST}${url}`, config);
};

const post = async (url, data = {}, withAuth = true, cancelToken = (c) => {}) => {
  const config = {
    headers: {
      'Content-Type': 'application/json',
    },
    cancelToken: new CancelToken(cancelToken),
  };
  if (withAuth) {
    try {
      const auth = await authHeader();
      config.headers = { ...config.headers, ...auth };
    } catch (e) {
      return e;
    }
  }

  return axios.post(`${process.env.REACT_APP_HOST}${url}`, data, config);
};

const put = async (url, data = {}, withAuth = true, cancelToken = (c) => {}) => {
  const config = {
    headers: {
      'Content-Type': 'application/json',
    },
    cancelToken: new CancelToken(cancelToken),
  };
  if (withAuth) {
    try {
      const auth = await authHeader();
      config.headers = { ...config.headers, ...auth };
    } catch (e) {
      return e;
    }
  }

  return axios.put(`${process.env.REACT_APP_HOST}${url}`, data, config);
};

const del = async (url, withAuth = true, cancelToken = (c) => {}) => {
  const config = {
    headers: {
      'Content-Type': 'application/json',
    },
    cancelToken: new CancelToken(cancelToken),
  };
  if (withAuth) {
    try {
      const auth = await authHeader();
      config.headers = { ...config.headers, ...auth };
    } catch (e) {
      return e;
    }
  }

  return axios.delete(`${process.env.REACT_APP_HOST}${url}`, config);
};

export const http = {
  get,
  post,
  put,
  del,
};

export const handleError = (err) => {
  const { response } = err;
  if ([401, 403].indexOf(response.status) !== -1) {
    localStorage.setItem('tokenType', '');
    localStorage.setItem('accessToken', '');
    localStorage.setItem('refreshToken', '');
    localStorage.setItem('expiresIn', '0');
  }
  return err;
};

const authHeader = async () => {
  const accessToken = localStorage.getItem('accessToken');
  try {
    if (accessToken) {
      const tokenType = localStorage.getItem('tokenType');
      // eslint-disable-next-line radix
      const expiresIn = parseInt(localStorage.getItem('expiresIn'));
      const now = new Date();
      const currentUnixSeconds = Math.round(now.getTime() / 1000);

      if (currentUnixSeconds >= expiresIn) {
        const refreshToken = localStorage.getItem('refreshToken');
        const payload = {
          accessToken,
          refreshToken,
        };
        const { data } = await post('/v1/users/token', payload, false);
        localStorage.setItem('accessToken', data.accessToken);
        localStorage.setItem('refreshToken', data.refreshToken);
        localStorage.setItem('expiresIn', data.expiresIn);
        return authHeader();
      }
      return { Authorization: `${tokenType} ${accessToken}` };
    }
    throw Error('Unauthorized');
  } catch (e) {
    throw handleError(e);
  }
};
